import { createAction } from 'typesafe-actions';
import { ActionTypes } from '../types';

export const setColor = createAction(ActionTypes.SET_COLOR)<string>();
